/**
 * @fileoverview View mode content for production order details modal
 */
import React from "react";
import PropTypes from "prop-types";
import { intl } from "dmsbasereact";
import { Box, Grid } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { DmsInfoCard } from "../../DmsDetailModal/DmsInfoCard";
import { DmsInfoField } from "../../DmsDetailModal/DmsInfoField";

/**
 * Format datetime for display
 */
const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * View mode content for displaying production order details
 */
export const ViewModeContent = ({ data }) => {
  const order = data;
  
  if (!order) {
    return null;
  }

  return (
    <Box sx={{ maxHeight: "70vh", overflowY: "auto" }}>
      {/* Order Information */}
      <DmsInfoCard icon={<AssignmentIcon />} title={intl.get("OrderInfo").d("Order Information")}>
        <Grid container spacing={2}>
          <DmsInfoField 
            label={intl.get("OrderNumber").d("Order Number")} 
            value={order.order_number} 
            xs={12}
            sm={6}
          />
          <DmsInfoField 
            label={intl.get("PK").d("Internal ID (PK)")} 
            value={order.pk} 
            xs={6}
            sm={3}
          />
        </Grid>
      </DmsInfoCard>

      {/* Schedule Information */}
      <DmsInfoCard icon={<AccessTimeIcon />} title={intl.get("ScheduleInfo").d("Schedule Information")}>
        <Grid container spacing={2}>
          <DmsInfoField 
            label={intl.get("ScheduledTo").d("Scheduled For")} 
            value={formatDateTime(order.scheduled_to)} 
            xs={12}
            sm={6}
          />
          <DmsInfoField 
            label={intl.get("CreatedOn").d("Created On")} 
            value={formatDateTime(order.created_on)} 
            xs={12}
            sm={6}
          />
          <DmsInfoField 
            label={intl.get("UpdatedOn").d("Updated On")} 
            value={formatDateTime(order.updated_on)} 
            xs={12}
            sm={6}
          />
        </Grid>
      </DmsInfoCard>
    </Box>
  );
};

ViewModeContent.propTypes = {
  data: PropTypes.object.isRequired,
};

